import React from "react";

import { InnerContentWrap, useBreakpointV2 } from "@tm/ui-widgets";
import {
  FlexComp,
  FormattedText,
  H2Tag,
  H5Tag,
  ImageComponent,
  ParaTag,
  SpanTag,
  TextNodeType,
} from "@tm/ui-widgets/components";
import { theme } from "@tm/utility/global";
import {
  ShieldWrap,
  WhyBuyItem,
  WhyBuyTravInsStyle,
  WhyFeatListWrap,
} from "./WhyBuyTravIns.style";

interface WhyBuyTravInsInterFace {
  title?: TextNodeType;
  info?: TextNodeType;
  data: {
    icon: string;
    info: TextNodeType;
  }[];
}

const WhyBuyTravIns: React.FC<WhyBuyTravInsInterFace> = ({
  title,
  info,
  data,
}) => {
  const device = useBreakpointV2();
  return (
    <WhyBuyTravInsStyle>
      <InnerContentWrap>
        <FlexComp
          // flexWrap="wrap"
          flexDirection={device == "lg" ? "row" : "column"}
          alignItems="center"
          gap={device == "lg" ? "74px" : "24px"}
        >
          <div>
            {device == "lg" ? (
              <H2Tag margin="0 0 60px">
                {title && <FormattedText value={title} />}
              </H2Tag>
            ) : (
              <H5Tag margin="0 0 20px">
                {" "}
                {title && <FormattedText value={title} />}
              </H5Tag>
            )}
            <ParaTag
              fontSize={device == "lg" ? "large" : "sm"}
              color={theme.greyText}
            >
              {info && <FormattedText value={info} />}
            </ParaTag>
          </div>
          <WhyFeatListWrap>
            {data &&
              data.map((item, index) => {
                return (
                  <WhyBuyItem key={index}>
                    {item.icon && (
                      <ImageComponent src={item.icon} height="24" width="24" />
                    )}
                    <SpanTag>
                      <FormattedText value={item?.info} />
                    </SpanTag>
                  </WhyBuyItem>
                );
              })}
          </WhyFeatListWrap>
          {device == "lg" && (
            <ShieldWrap>
              <ImageComponent
                width="286px"
                height="320px"
                src="https://tripmoneycmsimgak.mmtcdn.com/img/Light_Green_Shield_5cb1aff4ce.svg"
              />
            </ShieldWrap>
          )}
        </FlexComp>
      </InnerContentWrap>
    </WhyBuyTravInsStyle>
  );
};

export default WhyBuyTravIns;
